import { Elements, ElementTypes } from './elements';

const MAX_X = 18;
const MAX_Y = 10;

type Element = {
  element: string;
  name: string;
  type: ElementTypes;
};

export type ElementsTable = (Element | null)[][];

export const createElementsTable = (elements: Elements): ElementsTable => {
  const table: ElementsTable = Array.from({ length: MAX_Y }, () => Array.from({ length: MAX_X }, () => null));

  for (const [element, { x, y, type, name }] of Object.entries(elements)) {
    table[y - 1][x - 1] = { element, name, type };
  }

  return table;
};
